import { render, staticRenderFns } from "./ClassScheduleDetail.vue?vue&type=template&id=4b47364a&scoped=true&"
import script from "./ClassScheduleDetail.vue?vue&type=script&lang=js&"
export * from "./ClassScheduleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassScheduleDetail.vue?vue&type=style&index=0&id=4b47364a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47364a",
  null
  
)

export default component.exports